export default __webpack_public_path__ + "d5e7dded99b019e72bc166ce6e0f52c9.png";